import { render, staticRenderFns } from "./seoBreadcrumb.vue?vue&type=template&id=1f5acef6&"
import script from "./seoBreadcrumb.ts?vue&type=script&lang=js&"
export * from "./seoBreadcrumb.ts?vue&type=script&lang=js&"
import style0 from "./seoBreadcrumb.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports